import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import StatCard from '../components/StatCard';
import Chart from '../components/Chart';

interface Studio {
  gameId: string;
  email: string;
  tier: string;
  minted: number;
  verifications: number;
  dupesCaught: number;
  status: 'active' | 'inactive';
}

const mockStudios: Studio[] = [
  {
    gameId: 'GAME_001',
    email: 'studio@example.com',
    tier: 'Studio',
    minted: 1842,
    verifications: 24601,
    dupesCaught: 47,
    status: 'active',
  },
];

const mockChartData = [
  { label: 'Mon', value: 24601 },
  { label: 'Tue', value: 28400 },
  { label: 'Wed', value: 22100 },
  { label: 'Thu', value: 31200 },
  { label: 'Fri', value: 29800 },
  { label: 'Sat', value: 18900 },
  { label: 'Sun', value: 21400 },
];

export default function AdminDashboard() {
  const [studios] = useState<Studio[]>(mockStudios);

  const totalMinted = studios.reduce((a, s) => a + s.minted, 0);
  const totalVerifications = studios.reduce((a, s) => a + s.verifications, 0);
  const totalDupes = studios.reduce((a, s) => a + s.dupesCaught, 0);

  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      <div className="max-w-7xl mx-auto px-8 py-10">

        <div className="mb-8">
          <h2 className="text-2xl font-bold text-white">Admin Overview</h2>
          <p className="text-gray-400 mt-1">All studios — GameChain network</p>
        </div>

        {/* Global Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          <StatCard label="Active Studios" value={studios.filter(s => s.status === 'active').length} color="green" />
          <StatCard label="Total Items Minted" value={totalMinted.toLocaleString()} color="blue" />
          <StatCard label="Total Verifications" value={totalVerifications.toLocaleString()} color="blue" />
          <StatCard label="Total Dupes Caught" value={totalDupes.toLocaleString()} color="red" />
        </div>

        {/* Chart */}
        <div className="mb-8">
          <Chart data={mockChartData} title="Network Verifications This Week" color="#3b82f6" />
        </div>

        {/* Studios Table */}
        <div className="bg-gray-900 rounded-xl shadow-lg overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-800">
            <p className="text-gray-300 font-semibold">Studios</p>
          </div>
          <table className="w-full">
            <thead>
              <tr className="text-gray-500 text-xs uppercase border-b border-gray-800">
                <th className="px-6 py-3 text-left">Game ID</th>
                <th className="px-6 py-3 text-left">Email</th>
                <th className="px-6 py-3 text-left">Tier</th>
                <th className="px-6 py-3 text-right">Minted</th>
                <th className="px-6 py-3 text-right">Verifications</th>
                <th className="px-6 py-3 text-right">Dupes Caught</th>
                <th className="px-6 py-3 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {studios.map((s, i) => (
                <tr key={i} className="border-b border-gray-800 hover:bg-gray-800 transition">
                  <td className="px-6 py-4 text-white font-mono text-sm">{s.gameId}</td>
                  <td className="px-6 py-4 text-gray-300 text-sm">{s.email}</td>
                  <td className="px-6 py-4">
                    <span className="bg-blue-900 text-blue-300 text-xs px-2 py-1 rounded-full">{s.tier}</span>
                  </td>
                  <td className="px-6 py-4 text-gray-300 text-sm text-right">{s.minted.toLocaleString()}</td>
                  <td className="px-6 py-4 text-gray-300 text-sm text-right">{s.verifications.toLocaleString()}</td>
                  <td className="px-6 py-4 text-red-400 text-sm text-right">{s.dupesCaught}</td>
                  <td className="px-6 py-4">
                    <span className={`text-xs px-2 py-1 rounded-full ${s.status === 'active' ? 'bg-green-900 text-green-300' : 'bg-gray-800 text-gray-400'}`}>
                      {s.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}